// Substitui o registro de mesmo id ou o adiciona ao fim da lista
export function upsertById<T extends { id: number }>(items: T[], saved: T): T[] {
    return items.some((i) => i.id === saved.id) ? items.map((i) => (i.id === saved.id ? saved : i)) : [...items, saved];
}

export function removeById<T extends { id: number }>(items: T[], id: number): T[] {
    return items.filter((i) => i.id !== id);
}
